module.exports = __webpack_public_path__ + "static/media/twitter.6620c8ae.svg";